import { useRouter } from 'expo-router'
import { useState } from 'react'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Input } from '@/src/elements/input'
import { ModalInput } from '@/src/elements/input/ModalInput/ModalInput'
import { Message } from '@/src/elements/message'
import { useAuthentication } from '@/src/features/auth/services/useAuthentication'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

const allowedDeleteConfirmations = new Set(['SUPPRIMER', 'DELETE', 'DELETAR', 'ELIMINAR'])

export const DeleteAccountForm = () => {
  const [inputValue, setInputValue] = useState('')
  const [error, setError] = useState('')
  const { t } = useTranslate()
  const { replace } = useRouter()
  const { routes } = useRoutes()
  const { deleteAccount } = useAuthentication()

  const handleUncaughtSubmit = async () => {
    setError('')

    if (allowedDeleteConfirmations.has(inputValue)) {
      deleteAccount()
        .then(() => replace(routes.leaveHozana()))
        .catch(() => setError(t('common.error.api.default')))
    } else {
      setInputValue('')
      setError(t('settings.account.delete.error-input'))
      throw new Error('DELETE has been wrongly written')
    }
  }

  const handleClose = () => {
    setError('')
    setInputValue('')
  }

  return (
    <>
      <ModalInput
        testID={TEST_ID.SETTINGS.DELETE_ACCOUNT.MODAL}
        onCancel={handleClose}
        title={t('settings.account.delete')}
        confirmText={t('word.confirm')}
        confirmButtonProps={{ colors: 'danger', testID: TEST_ID.SETTINGS.DELETE_ACCOUNT.CONFIRM }}
        cancelButtonProps={{ testID: TEST_ID.SETTINGS.DELETE_ACCOUNT.CANCEL }}
        onUncaughtSubmit={handleUncaughtSubmit}
        renderTrigger={({ onTrigger }) => (
          <Button
            testID={TEST_ID.SETTINGS.DELETE_ACCOUNT.BUTTON}
            colors="default"
            contrast="low"
            variant="light"
            onPress={onTrigger}
            className="self-start text-gray-400 mt-10 !px-4"
          >
            {t('settings.account.delete')}
          </Button>
        )}
      >
        {({ onSubmitEditing }) => (
          <View className="flex flex-col gap-3">
            <Message iconName={ICON.ALERT_TRIANGLE} colors="danger">
              {t('settings.account.delete.confirm')}
            </Message>
            <Input
              testID={TEST_ID.SETTINGS.DELETE_ACCOUNT.INPUT}
              placeholder={t('settings.account.delete.input')}
              value={inputValue}
              onChangeText={setInputValue}
              errorMessage={error}
              onSubmitEditing={onSubmitEditing}
            />
          </View>
        )}
      </ModalInput>
    </>
  )
}
